import React from 'react';

import CustomTd from '../table/CustomTd';
import EditDeleteButton from '../buttons/EditDeleteButton';
import postData from '../../../utilities/postData';
import PropTypes from 'prop-types';

const NameFranchiseItem = ({
    deleteUrl,
    editItem,
    viewItem,
    fetchData,
    hideFranchise,
    showExternal,
    item
}) => {
    function deleteItem(itemId) {
        postData(`${deleteUrl}/${itemId}`, null, fetchData);
    }

    return (
        <tr>
            <CustomTd>
                <div style={{ height: '1.9em', paddingTop:'.2em' }}>
                    {item.name}
                </div>
            </CustomTd>
            {window.biztrax.showFranchise && !hideFranchise &&
                <CustomTd>
                <div style={{ height: '1.9em', paddingTop: '.2em'  }}>
                        {item.franchiseName}
                    </div>
                </CustomTd>
            }
            {showExternal &&
                <CustomTd>
                    <div style={{ height: '1.9em', paddingTop: '2px' }}>
                        {item.externallyVisible && '✓'}
                    </div>
                </CustomTd>
            }
            <CustomTd className="two-button-cell">
                <EditDeleteButton
                    acl={item.acl}
                    editItem={editItem}
                    viewItem={viewItem}
                    deleteItem={() => deleteItem(item.id)} />
            </CustomTd>
        </tr>
    );
}

NameFranchiseItem.propTypes = {
    deleteUrl: PropTypes.string,
    editItem: PropTypes.func,
    fetchData: PropTypes.func,
    hideFranchise: PropTypes.bool
};

export default NameFranchiseItem;